module.exports = __webpack_public_path__ + "img/iso-combles-amenageables.d2ea3d3c.svg";